import { BadgeType } from 'components/badge/badge';

// ScoreType: 1 = سفارش، 2 = زیرمجموعه، 3 = سفارش زیرمجموعه
export const scoreTypeBadge = (id: number): BadgeType => {
    switch (id) {
        case 1:
            return 'info';
        case 2:
            return 'success';
        case 3:
            return 'primary';
        default:
            return 'secondary';
    }
};
